import React from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components/macro'

import LoadingIndicator from '../ui/LoadingIndicator'
import Carousel from './Carousel'
import EntryOverview from './EntryOverview'
import EntryReviews from './EntryReviews'
import Lightbox from './lightbox/Lightbox'

const TextContent = styled.article`
  padding: 12px;

  box-sizing: border-box;

  ul {
    margin-block: 0 12px;
    margin-inline: 0;
  }
`

const EntryDesktop = () => {
  const { reviews, isLoading } = useSelector((state) => state.location)

  if (isLoading) {
    return <LoadingIndicator cover vertical />
  }

  return (
    <div>
      <Lightbox />
      <Carousel />
      <TextContent>
        <EntryOverview />
      </TextContent>
      {reviews.length > 0 && (
        <TextContent>
          <EntryReviews />
        </TextContent>
      )}
    </div>
  )
}

export default EntryDesktop
